import React from 'react'
import { useTranslation } from 'react-i18next'
import { format } from 'date-fns'
import Author from '../author'
import { CardSC, HeaderRow, MainRow, Wrapper } from './card.styled'
// import { ReactComponent as SyncSVG } from '../../../assets/icon-reload-green.svg'

interface ICardProps {
  date: string | Date
}

const Card: React.FC<ICardProps> = ({ children, date }) => {
  const { t } = useTranslation()
  return (
    <Wrapper>
      <Author />
      <CardSC>
        <HeaderRow>
          <h2>{t('general.header')}</h2>
          <div>
            <span>{format(new Date(date), 'd.M.y k:mm')}</span>
          </div>
        </HeaderRow>
        <MainRow>{children}</MainRow>
      </CardSC>
    </Wrapper>
  )
}

export default Card
